<template>
  <nuxt-loading-indicator color="#e51d1d" />

  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
</template>
